import { CATEGORY_COLORS } from "@/lib/constants";

export const ScoreGauge = ({ score, category }) => {
  const radius = 84;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (score / 100) * circumference;
  const color = CATEGORY_COLORS[category] || "#6B8E74";

  return (
    <div className="relative w-56 h-56 mx-auto" data-testid="score-gauge">
      <svg width="224" height="224" viewBox="0 0 224 224" className="-rotate-90">
        <circle
          className="gauge-track"
          cx="112"
          cy="112"
          r={radius}
          fill="none"
          strokeWidth="14"
        />
        <circle
          className="gauge-fill"
          cx="112"
          cy="112"
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth="14"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-6xl font-serif text-[#2C3E35]" data-testid="score-value">
          {score}
        </span>
        <span className="text-sm text-[#8FA38C] font-medium">op 100</span>
      </div>
    </div>
  );
};

export const DomainBars = ({ subscores, domains }) => {
  return (
    <div className="space-y-4" data-testid="domain-subscores">
      {Object.entries(domains).map(([key, label]) => {
        const value = subscores[key] ?? 0;
        const color =
          value >= 75 ? "#6B8E6A" : value >= 50 ? "#E3A857" : "#C86B5E";
        return (
          <div key={key} data-testid={`subscore-${key}`}>
            <div className="flex justify-between text-sm mb-1.5">
              <span className="text-[#2C3E35] font-medium">{label}</span>
              <span className="text-[#5B6B61] tabular-nums">{value}/100</span>
            </div>
            <div className="h-2.5 rounded-full bg-[#EDEFE9] overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-700"
                style={{ width: `${value}%`, backgroundColor: color }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
